import {
    createTextHeader,
    TextHeader,
} from '@vfde-brix/ws10/text-header';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { ADDITIONAL_PAGE_OPTIONS } from '@vfde-sails/constants';
import { mapStateToProps } from 'Container/App/selectors';
import { startAppListening } from 'Container/App/listener';

/**
 * Mount TextHeader
 */
const mountTextHeader = (containerId: string): TextHeader | null => {
    const container = document.getElementById(containerId);

    const textHeader = container && createTextHeader(container, NO_PATTERN_BUSINESS_LOGIC);

    startAppListening({
        predicate: (action, currentState, previousState) => {
            const currentStateProps = mapStateToProps(currentState);
            const previousStateProps = mapStateToProps(previousState);

            return currentStateProps.customerConfig.isHardwareOnly !== previousStateProps.customerConfig.isHardwareOnly
                || currentStateProps.customerConfig.paymentMethod !== previousStateProps.customerConfig.paymentMethod
                || currentStateProps.atomicDevice !== previousStateProps.atomicDevice;
        },
        effect: (action, listenerApi) => {
            listenerApi.cancelActiveListeners();

            const stateProps = mapStateToProps(listenerApi.getState());

            const headlineParts = [
                stateProps.device?.modelName,
            ].filter(Boolean);

            const { isHardwareOnly, paymentMethod } = stateProps.customerConfig;

            if (paymentMethod !== undefined && !isHardwareOnly) {
                headlineParts.push(window[ADDITIONAL_PAGE_OPTIONS].textHeader.withTariffHeadline);
            }

            textHeader?.update({
                stdHeadline: headlineParts.join(' '),
            });
        },
    });

    return textHeader;
};

export default mountTextHeader;
